import React, { Fragment } from "react";
import ImageTextItem from "./ImageTextItem";
import MultiCarousel from "./MultiCarouselElements/MultiCarousel";
import MultiCarouselArrows from "./MultiCarouselElements/MultiCarouselArrows";
import * as debounce from "lodash.debounce";

class TextImageSlider extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            isMounted: false,
            screenWidth: window.screen.width
        };
        this.handleResize = this.handleResize.bind(this);
        let responsiveness = {
            desktop: {
                breakpoint: { max: 9999, min: 1024 },
                items: 4,
                slidesToSlide: 4,
            },
            tablet: {
                breakpoint: { max: 1024, min: 464 },
                items: 2,
                slidesToSlide: 2,
            },
            mobile: {
                breakpoint: { max: 464, min: 0 },
                items: 1,
                slidesToSlide: 1,
                partialVisibilityGutter: 80,
            }
        }
        this.settings = {
            swipeable: true,
            draggable: false,
            showDots: false,
            arrows: false,
            responsive: responsiveness,
            keyBoardControl: true,
            itemClass: "carousel-item ",
            containerClass: "text-image-slider__slider-container",
            partialVisible: false,
            minimumTouchDrag: 10,
            renderButtonGroupOutside: true,
            transitionDuration: 300,
            customButtonGroup: <MultiCarouselArrows cssBlock="text-image-slider" />,
            partialVisible: true
        }
    }

    componentDidMount() {
        if (this.props.items) {
            this.setState({
                isMounted: true,
            });
            window.addEventListener("resize", this.handleResize);
        }
    }

    handleResize = debounce(
        () => {
            this.setState({
                screenWidth: window.screen.width
            });
        },
        500
    );

    children = (items) => {
        return (
            items.map((item, index) => (
                <ImageTextItem item={item} key={index} />
            ))
        )
    };

    render() {
        const { items } = this.props;
        return (
            items && this.state.isMounted &&
            <div className={`text-image-slider items-${items.length} ${items.length > 3 ? "text-image-slider--mobile-slider " : ""} `}>
                {((items.length > 4) || ((items.length > 3) && (this.state.screenWidth < 464))) ?
                    <Fragment>
                        <MultiCarousel settings={this.settings} children={this.children(items)} items={items} cssBlock="text-image-slider" />
                    </Fragment>
                    :
                    items.map((item, index) =>
                        <ImageTextItem item={item} key={index} />
                    )
                }
            </div>
        );
    }
}

export default TextImageSlider;